import { render, staticRenderFns } from "./StudyTest.vue?vue&type=template&id=075f2209&"
import script from "./StudyTest.vue?vue&type=script&lang=js&"
export * from "./StudyTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports